export const footer = {
  it: {
    contact: {
      title: "Contatti",
      email: "victor@victorlazari.com",
      phone: "+39 380 633 1704",
      address: "San Pietro in Vinoli, Ravenna, 48125, Italia",
      hq: "HQ: Ravenna, Emilia-Romagna"
    },
    brand: {
      role: "System Architect",
      description: "Costruisco infrastrutture digitali per aziende che non accettano compromessi. Performance, sicurezza e automazione."
    },
    quickLinks: {
      title: "Link Rapidi",
      home: "Home",
      solutions: "Soluzioni",
      blog: "Blog",
      testimonials: "Testimonianze",
      contact: "Contatti"
    },
    services: {
      title: "Servizi",
      launch: "Launch — Sito + CRM",
      automations: "Automazioni WhatsApp 24/7",
      dashboard: "Dashboard KPI mensili",
      consulting: "Supporto & consulenza"
    },
    legal: {
      title: "Legale",
      privacy: "Privacy",
      terms: "Termini di Servizio",
      cookies: "Cookies",
      preferences: "Preferenze Cookie"
    },
    rights: "Tutti i diritti riservati",
    copyright: "© {{year}} Victor Lazari. Tutti i diritti riservati"
  },
  en: {
    contact: {
      title: "Contact",
      email: "victor@victorlazari.com",
      phone: "+39 380 633 1704",
      address: "San Pietro in Vinoli, Ravenna, 48125, Italy",
      hq: "HQ: Ravenna, Emilia-Romagna"
    },
    brand: {
      role: "System Architect",
      description: "I build digital infrastructures for companies that don't accept compromises. Performance, security, and automation."
    },
    quickLinks: {
      title: "Quick Links",
      home: "Home",
      solutions: "Solutions",
      blog: "Blog",
      testimonials: "Testimonials",
      contact: "Contact"
    },
    services: {
      title: "Services",
      launch: "Launch — Website + CRM",
      automations: "24/7 WhatsApp Automations",
      dashboard: "Monthly KPI Dashboard",
      consulting: "Ongoing Support & Consulting"
    },
    legal: {
      title: "Legal",
      privacy: "Privacy",
      terms: "Terms of Service",
      cookies: "Cookies",
      preferences: "Cookie Preferences"
    },
    rights: "All rights reserved",
    copyright: "© {{year}} Victor Lazari. All rights reserved"
  }
};